// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import AddressFormComponent from '../../AddressForm/AddressForm';
import AddressVerification from '../../AddressVerification/container/AddressVerification.container';
import styles from '../styles/AddEditAddress.style';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import globalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
  lblAddEditAddressAddAddress,
  lblAddEditAddressEditAddress,
} from '../../../../../utils/labels/globalAddEditAddress.labels';

export const AddEditAddress = ({
  className,
  isEdit,
  initialValues,
  backToAddressBookClick,
  verifyAddressAction,
  submitAddressFormAction,
  isMakeDefaultDisabled,
  addEditErrorMessage,
  showNotification,
  submitErrors,
  mapboxAutocompleteTypesParam,
  mapboxSwitch,
  isInternationalPhoneNumberEnabled,
  newGlobalErrorMessageEnabled,
}) => {
  return (
    <div className={`${className} addEditAddress`}>
      <Grid>
        {addEditErrorMessage && showNotification && !newGlobalErrorMessageEnabled && (
          <Notification
            isError
            status="error"
            colSize={{ large: 12, medium: 8, small: 6 }}
            message={addEditErrorMessage}
          />
        )}
        {submitErrors && submitErrors.address && !newGlobalErrorMessageEnabled && (
          <Notification
            isError
            status="error"
            scrollIntoView
            isErrorTriangleIcon
            message={submitErrors && submitErrors.address && submitErrors.address.formGeneric}
          />
        )}

        <AddressVerification
          onSuccess={submitAddressFormAction}
          heading={
            isEdit
              ? getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ADD_EDIT_ADDRESS_LABELS}.${lblAddEditAddressEditAddress}`,
                  globalAddEditAddressLabels
                )
              : getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ADD_EDIT_ADDRESS_LABELS}.${lblAddEditAddressAddAddress}`,
                  globalAddEditAddressLabels
                )
          }
          onError={submitAddressFormAction}
        />
        <AddressFormComponent
          backToAddressBookClick={backToAddressBookClick}
          onSubmit={verifyAddressAction}
          initialValues={initialValues}
          isEdit={isEdit}
          isMakeDefaultDisabled={isMakeDefaultDisabled}
          mapboxAutocompleteTypesParam={mapboxAutocompleteTypesParam}
          mapboxSwitch={mapboxSwitch}
          isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
        />
      </Grid>
    </div>
  );
};

AddEditAddress.propTypes = {
  className: PropTypes.string,
  submitAddressFormAction: PropTypes.func,
  verifyAddressAction: PropTypes.func,
  backToAddressBookClick: PropTypes.func,
  addressResponse: PropTypes.shape({}),
  initialValues: PropTypes.shape({}),
  isEdit: PropTypes.bool,
  isMakeDefaultDisabled: PropTypes.bool,
  addEditErrorMessage: PropTypes.string.isRequired,
  showNotification: PropTypes.bool,
  submitErrors: PropTypes.shape({}),
  mapboxAutocompleteTypesParam: PropTypes.string,
  mapboxSwitch: PropTypes.bool,
};

AddEditAddress.defaultProps = {
  className: '',
  submitAddressFormAction: () => {},
  verifyAddressAction: () => {},
  backToAddressBookClick: () => {},
  initialValues: {},
  addressResponse: null,
  isEdit: false,
  isMakeDefaultDisabled: false,
  showNotification: false,
  submitErrors: null,
  mapboxAutocompleteTypesParam: '',
  mapboxSwitch: true,
};

export default withStyles(AddEditAddress, styles);
